export const blockIconsTravelLocationCityNew = (
	<span className='material-symbols-outlined'>location_city</span>
);
